import { atomWithReset } from "jotai/utils";
import { JoinedUserRole, User, UserRole } from "@/DatabaseControls/DataTypes";

export const currentUserState = atomWithReset<User | null>(null);

export const currentUserRoleState = atomWithReset<JoinedUserRole | null>(null);

export const allUserRolesState = atomWithReset<JoinedUserRole[]>([]);
